import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChapterReportLayer from "../components/ChapterReportLayer";

const ChapterReportPage = () => {
    return (
        <MasterLayout>
            <ChapterReportLayer />
        </MasterLayout>
    );
};

export default ChapterReportPage;
